import styled from 'styled-components';

interface BottomActionBarProps {
  backgroundColor?: string;
  bottom?: string;
  marginBottom?: string;
  marginTop?: string;
  padding?: string;
  position?: string;
  top?: string;
}

const BottomActionBar = styled.div<BottomActionBarProps>`
  position: fixed;
  display: flex;
  left: 0;
  bottom: 0;
  background: ${({ backgroundColor }) => backgroundColor || 'white'};
  width: 100vw;
  z-index: 500;
  border-top: solid 1px lightgrey;
  height: 70px;
`;

export { BottomActionBar };
